import AxiosManager from "../_axiosManager";

export async function delFoldingScreen(foldingScreenId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/foldingscreen/${foldingScreenId}`,
  );

  return res;
}

export async function getFoldingScreenDetail(foldingScreenId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/foldingscreen/${foldingScreenId}`,
  );

  return res;
}

export async function postFoldingScreen(body: any) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/foldingscreen",
    body,
  );

  return res;
}

export async function putFoldingScreem({ foldingScreenId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/foldingscreen/${foldingScreenId}`,
    body,
  );

  return res;
}

export async function delTableSetting(tableSettingId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/tablesetting/${tableSettingId}`,
  );

  return res;
}

export async function getTableSettingDetail(tableSettingId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/tablesetting/${tableSettingId}`,
  );

  return res;
}

export async function postTableSetting(body: any) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/tablesetting",
    body,
  );

  return res;
}

export async function putTableSetting({ tableSettingId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/tablesetting/${tableSettingId}`,
    body,
  );

  return res;
}
